import { CODEIT_META_KEY } from 'apps/main/deprecated/shared/constants'
import { NX_PUBLIC_ASSET_URL } from 'apps/main/env'
import Head from 'next/head'

type OgTagsProps = {
  title: string
  description: string
  url?: string
  imageSource?: string
}

const OgTags = ({
  title,
  description,
  url,
  imageSource = `${NX_PUBLIC_ASSET_URL}${CODEIT_META_KEY.IMG_DIRECTORY}`,
}: OgTagsProps) => {
  return (
    <Head>
      <meta property="og:title" content={title} key="title" />
      <meta name="description" property="og:description" content={description} key="description" />
      {imageSource && <meta property="og:image" content={imageSource} key="image" />}
      {url && <meta property="og:url" content={url} key="url" />}
    </Head>
  )
}

export default OgTags
